import { render } from "./CustomPage.vue?vue&type=template&id=7bd81c87&scoped=true"
import script from "./CustomPage.vue?vue&type=script&lang=js"
export * from "./CustomPage.vue?vue&type=script&lang=js"

import "./CustomPage.vue?vue&type=style&index=0&id=7bd81c87&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bd81c87"]])

export default __exports__